import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16c29efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listItem" }
const _hoisted_2 = { class: "listItemHeader" }
const _hoisted_3 = { class: "vendorName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_button = _resolveComponent("toggle-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_toggle_button, {
        onChange: _ctx.changeConsent,
        sync: true,
        value: _ctx.consent,
        width: 64,
        height: 30,
        speed: 200,
        color: {checked: '#34b76f', unchecked: '#94a7d1'}
      }, null, 8, ["onChange", "value"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label), 1)
    ])
  ]))
}